import { IPermissionStore } from './permission-store';
import { IAccessRight, AccessRightMode, PermissionKey } from '../types';

export interface IAuthorizer<TPermissionKey extends PermissionKey> {
    registerAccessRights(...accessRights: Array<IAccessRight<TPermissionKey>>): void;
    authorize(accessRightName: string): boolean;
}

export function createAuthorizer<TPermissionKey extends PermissionKey>(permissionStore: IPermissionStore<TPermissionKey>) {
    const accessRights = new Map<String, IAccessRight<TPermissionKey>>();
    return {

        registerAccessRights(...accessRightConfigs: Array<IAccessRight<TPermissionKey>>) {
            accessRightConfigs.forEach(right => accessRights.set(right.name, right));
        },

        authorize(accessRightName: string): boolean {
            const accessRightInfo = accessRights.get(accessRightName);
            return accessRightInfo !== undefined && accessRightInfo.permissions[accessRightInfo.mode === AccessRightMode.all ? 'every' : 'some'](permissionKey => permissionStore.has(permissionKey));
        }

    };

}
